import { gql } from '@apollo/client';

export const LanguageFragment = gql`
  fragment Language on Language {
    code
    label
  }
`;
